module.exports = __webpack_public_path__ + "static/img/8areaA_06.81945b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/8areaA_06.png
// module id = 1053
// module chunks = 1